import React from "react";
import { Logo } from "../../_components/Logo";

import './TeamsList.css';
import {InlineLoading} from "../../_components/InlineLoading";

class TeamsList extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { teams } = this.props;

        return teams.length === 0
            ? <div className="teams-list-empty">No teams registered yet</div>
            : (
                <div className="teams-list-container">
                    {teams.map((team, index) => (
                        <div key={index} className="team-item">
                            <div className="team-logo">
                                <Logo source={team.logo} />
                            </div>
                            <div className="team-name-column">
                                {team.name}
                            </div>
                            <div className="team-actions">
                                <InlineLoading visible={team.deleting} />
                                {!team.deleting && (
                                    <button
                                        type="button"
                                        className="delete-button"
                                        onClick={() => this.props.onRemoveRequest(team.id)}
                                    >
                                        Delete
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
    }
}

export default TeamsList;
